export function invalidAccountParser(statusDetails) {
  const parsedObj = {
    brokerage: null,
    accountNumber: null,
  };
  if (statusDetails) {
    parsedObj.brokerage = statusDetails.brokerage ?? null;
    parsedObj.accountNumber = statusDetails.accountNumber ?? null;
  }

  return parsedObj; 
}